import { Box, Modal } from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  ResponsiveContainer,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from "recharts";

const data = [
  {
    week: 22,
    weight: 0.5,
    weightLow: 0.4,
    weightHigh: 0.6,
    weightMin: 0.3,
    weightMax: 0.7,
    length: 24,
    lengthLow: 22,
    lengthHigh: 26,
    lengthMin: 20,
    lengthMax: 28,
    head: 16,
    headLow: 15,
    headHigh: 17,
    headMin: 14,
    headMax: 19,
  },

  {
    week: 24,
    weight: 0.8,
    weightLow: 0.7,
    weightHigh: 0.9,
    weightMin: 0.5,
    weightMax: 1.0,
    length: 27,
    lengthLow: 25,
    lengthHigh: 29,
    lengthMin: 24,
    lengthMax: 30,
    head: 18,
    headLow: 17,
    headHigh: 19,
    headMin: 16,
    headMax: 20,
  },

  {
    week: 26,
    weight: 1.2,
    weightLow: 1.0,
    weightHigh: 1.4,
    weightMin: 0.9,
    weightMax: 1.5,
    length: 30,
    lengthLow: 28,
    lengthHigh: 32,
    lengthMin: 27,
    lengthMax: 34,
    head: 20,
    headLow: 19,
    headHigh: 21,
    headMin: 18,
    headMax: 22,
  },

  {
    week: 28,
    weight: 1.8,
    weightLow: 1.6,
    weightHigh: 2.0,
    weightMin: 1.5,
    weightMax: 2.1,
    length: 34,
    lengthLow: 32,
    lengthHigh: 36,
    lengthMin: 31,
    lengthMax: 37,
    head: 22,
    headLow: 21,
    headHigh: 23,
    headMin: 20,
    headMax: 24,
  },

  {
    week: 30,
    weight: 2.5,
    weightLow: 2.3,
    weightHigh: 2.7,
    weightMin: 2.1,
    weightMax: 2.8,
    length: 37,
    lengthLow: 35,
    lengthHigh: 39,
    lengthMin: 34,
    lengthMax: 40,
    head: 24,
    headLow: 23,
    headHigh: 25,
    headMin: 22,
    headMax: 26,
  },

  {
    week: 32,
    weight: 3.3,
    weightLow: 3.0,
    weightHigh: 3.6,
    weightMin: 2.9,
    weightMax: 3.7,
    length: 41,
    lengthLow: 39,
    lengthHigh: 43,
    lengthMin: 38,
    lengthMax: 44,
    head: 26,
    headLow: 25,
    headHigh: 27,
    headMin: 24,
    headMax: 28,
  },

  {
    week: 34,
    weight: 4.2,
    weightLow: 3.8,
    weightHigh: 4.5,
    weightMin: 3.7,
    weightMax: 4.6,
    length: 44,
    lengthLow: 42,
    lengthHigh: 46,
    lengthMin: 41,
    lengthMax: 47,
    head: 28,
    headLow: 27,
    headHigh: 29,
    headMin: 26,
    headMax: 30,
  },

  {
    week: 36,
    weight: 5.0,
    weightLow: 4.6,
    weightHigh: 5.4,
    weightMin: 4.4,
    weightMax: 5.6,
    length: 47,
    lengthLow: 45,
    lengthHigh: 49,
    lengthMin: 44,
    lengthMax: 51,
    head: 30,
    headLow: 29,
    headHigh: 31,
    headMin: 28,
    headMax: 32,
  },

  {
    week: 38,
    weight: 5.8,
    weightLow: 5.4,
    weightHigh: 6.2,
    weightMin: 5.2,
    weightMax: 6.4,
    length: 50,
    lengthLow: 48,
    lengthHigh: 52,
    lengthMin: 47,
    lengthMax: 53,
    head: 32,
    headLow: 31,
    headHigh: 33,
    headMin: 30,
    headMax: 35,
  },

  {
    week: 40,
    weight: 6.5,
    weightLow: 6.0,
    weightHigh: 7.0,
    weightMin: 5.8,
    weightMax: 7.2,
    length: 53,
    lengthLow: 51,
    lengthHigh: 55,
    lengthMin: 50,
    lengthMax: 56,
    head: 34,
    headLow: 33,
    headHigh: 35,
    headMin: 31,
    headMax: 36,
  },
];

const Customs = (props) => {
  const [clickedData, setClickedData] = useState(null);
  const [tooltipPosition, setTooltipPosition] = useState(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest(".chart-container")) {
        setClickedData(null);
        setTooltipPosition(null);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  const containerStyle = {
    width: "100%",
    height: "800px",
    backgroundColor: "#f5f5f5",
    padding: "16px",
    borderRadius: "8px",
  };

  const headerStyle = {
    textAlign: "center",
    fontWeight: "bold",
    fontSize: "16px",
    backgroundColor: "#FFD700",
    padding: "10px",
    marginBottom: "10px",
  };

  const titleStyle = {
    textAlign: "center",
    fontWeight: "600",
    fontSize: "14px",
    marginBottom: "10px",
  };

  return (
    <Modal
      open={props.open}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "80%",
          bgcolor: "background.paper",
          border: "1px solid gray",
          // borderRadius: 1,
          boxShadow: 20,
          p: 4,
          overflow: "auto",
        }}
        className="h-[85%] w-[85%]"
      >
        <div className="flex justify-between p-2">
          <div>
            <h1 className="font-semibold text-lg">Growth Chart</h1>
          </div>
          <div className="flex justify-end">
            <button
              type="button"
              onClick={() => {
                props.setOpen(false);
              }}
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_13757_21637)">
                  <path
                    d="M14.59 8L12 10.59L9.41 8L8 9.41L10.59 12L8 14.59L9.41 16L12 13.41L14.59 16L16 14.59L13.41 12L16 9.41L14.59 8ZM12 2C6.47 2 2 6.47 2 12C2 17.53 6.47 22 12 22C17.53 22 22 17.53 22 12C22 6.47 17.53 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z"
                    fill="#D21919"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_13757_21637">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </button>
          </div>
        </div>
        <div style={containerStyle}>
          <h2 style={headerStyle}>MOTHER'S MILK IS BEST FOR THE BABY</h2>
          <h3 style={titleStyle}>FENTON PRETERM GROWTH CHART - BOYS</h3>

          <ResponsiveContainer width="100%" height={700}>
            <LineChart
              className="chart-container"
              data={data}
              onClick={(e) => {
                if (e?.activePayload && e?.chartX && e?.chartY) {
                  setClickedData(e.activePayload);
                  setTooltipPosition({ x: e?.chartX, y: e?.chartY });
                } else {
                  setClickedData(null);
                  setTooltipPosition(null);
                }
              }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis
                dataKey="week"
                label={{
                  value: "Gestational Age (weeks)",
                  position: "Outsidebottom",
                  dy: 10,
                }}
              />

              <YAxis
                yAxisId="left"
                domain={[0, 60]}
                ticks={[
                  0, 1, 2, 3, 4, 5, 7, 8, 10, 15, 20, 25, 30, 35, 40, 45, 50,
                  55, 60,
                ]}
                label={{
                  value: "Weight (kg) & Length (cm)",
                  angle: -90,
                  position: "insideleft",
                  dx: -20,
                  dy: 20,
                }}
              />
              <YAxis
                yAxisId="right"
                orientation="right"
                domain={[0, 7]}
                ticks={[
                  0, 1, 2, 3, 4, 5, 6, 6.5, 7, 10, 15, 20, 25, 30, 35, 40, 45,
                  50, 55, 60,
                ]}
                label={{
                  value: "Head Circumference (cm) & Weight (kg) ",
                  angle: 90,
                  position: "insidebottom",
                  dx: 20,
                  dy: 90,
                }}
              />
              <Tooltip
                content={clickedData ? undefined : () => null}
                position={tooltipPosition}
              />
              <Legend />

              <Line
                yAxisId="left"
                type="monotone"
                dataKey="length"
                stroke="blue"
                strokeWidth={2}
                name="Length (cm)"
                activeDot={{ r: 6 }}
              />
              <Line
                yAxisId="left"
                type="monotone"
                dataKey="lengthMin"
                stroke="blue"
                strokeDasharray="5 3"
                name="Length Min"
                activeDot={{ r: 6 }}
              />
              <Line
                yAxisId="left"
                type="monotone"
                dataKey="lengthLow"
                stroke="blue"
                strokeDasharray="5 3"
                name="Length Low"
                activeDot={{ r: 6 }}
              />
              <Line
                yAxisId="left"
                type="monotone"
                dataKey="lengthHigh"
                stroke="blue"
                strokeDasharray="5 3"
                name="Length High"
                activeDot={{ r: 6 }}
              />
              <Line
                yAxisId="left"
                type="monotone"
                dataKey="lengthMax"
                stroke="blue"
                strokeDasharray="5 3"
                name="Length Max"
                activeDot={{ r: 6 }}
              />

              <Line
                yAxisId="right"
                type="monotone"
                dataKey="head"
                stroke="red"
                strokeWidth={2}
                name="Head Circumference (cm)"
                activeDot={{ r: 6 }}
              />
              <Line
                yAxisId="right"
                type="monotone"
                dataKey="headMin"
                stroke="red"
                strokeDasharray="5 5"
                name="Head Circumference Min"
                activeDot={{ r: 6 }}
              />
              <Line
                yAxisId="right"
                type="monotone"
                dataKey="headLow"
                stroke="red"
                strokeDasharray="5 5"
                name="Head Circumference Low"
                activeDot={{ r: 6 }}
              />
              <Line
                yAxisId="right"
                type="monotone"
                dataKey="headHigh"
                stroke="red"
                strokeDasharray="5 5"
                name="Head Circumference High"
                activeDot={{ r: 6 }}
              />
              <Line
                yAxisId="right"
                type="monotone"
                dataKey="headMax"
                stroke="red"
                strokeDasharray="5 5"
                name="Head Circumference Max"
                activeDot={{ r: 6 }}
              />

              <Line
                yAxisId="right"
                type="monotone"
                dataKey="weight"
                stroke="black"
                strokeWidth={2}
                name="Weight (kg)"
                activeDot={{ r: 6 }}
              />
              <Line
                yAxisId="right"
                type="monotone"
                dataKey="weightMin"
                stroke="black"
                strokeDasharray="5 5"
                name="Weight Min"
                activeDot={{ r: 6 }}
              />
              <Line
                yAxisId="right"
                type="monotone"
                dataKey="weightLow"
                stroke="black"
                strokeDasharray="5 5"
                name="Weight Low"
                activeDot={{ r: 6 }}
              />
              <Line
                yAxisId="right"
                type="monotone"
                dataKey="weightHigh"
                stroke="black"
                strokeDasharray="5 5"
                name="Weight High"
                activeDot={{ r: 6 }}
              />
              <Line
                yAxisId="right"
                type="monotone"
                dataKey="weightMax"
                stroke="black"
                strokeDasharray="5 5"
                name="Weight Max"
                activeDot={{ r: 6 }}
              />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </Box>
    </Modal>
  );
};

export default Customs;
